/*
  <bp-checkout-bar> (T1 cart, 2026-10-21). Phone cart drawer: shows the pinned "Check out · total" button only while
  the drawer's real Check out button is out of view, and hides it while the real one is on screen. The button is a
  submit for the same cart form, so it behaves exactly like the real Check out. The drawer re-renders this markup with
  the cart (quantity / remove), so the total is always the server's; on every theme 'cart:update' the element
  re-observes the current real button, in case the update replaced that node. No animation (it appears and
  disappears), so reduced motion needs no special case.
*/
import { ThemeEvents } from '@theme/events';

class BpCheckoutBar extends HTMLElement {
  #controller = new AbortController();

  connectedCallback() {
    this.#observe();
    document.addEventListener(ThemeEvents.cartUpdate, () => requestAnimationFrame(() => this.#observe()), { signal: this.#controller.signal });
  }

  disconnectedCallback() {
    this.io?.disconnect();
    this.#controller.abort();
  }

  #observe() {
    this.io?.disconnect();
    const btn = this.querySelector('.bp-checkout-bar__btn');
    const drawer = this.closest('.cart-drawer__inner') || document;
    const real = drawer.querySelector('.cart-drawer__summary button[name="checkout"]');
    if (!btn || !real || !('IntersectionObserver' in window)) return;
    this.io = new IntersectionObserver(([e]) => {
      // shown only while the real button is out of view and enabled (not while the cart is updating)
      btn.hidden = e.isIntersecting || real.disabled;
    });
    this.io.observe(real);
  }
}

if (!customElements.get('bp-checkout-bar')) customElements.define('bp-checkout-bar', BpCheckoutBar);
